import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import styles from './style.module.scss';

// class Modal e

const Modal = (props) => {
  if (!props.visible) {
    return null;
  }
  return ReactDOM.createPortal((
    <>
      <div className={styles.mask}>
        <div className={styles.container}>
          <div className={styles.title}>
            <span>{props.title}</span>
            {
              props.closeBtn ? (
                <div
                  className={styles.close}
                  onClick={props.onClose}
                >
                  <img src={require('@/public/icon_close.svg')} alt="close" />
                </div>
              ) : null
            }
          </div>
          <div className={styles.content}>
            {props.children}
          </div>
        </div>
      </div>
    </>
  ), document.body);
};

Modal.propTypes = {
  title: PropTypes.any,
  children: PropTypes.any,
  visible: PropTypes.bool,
  closeBtn: PropTypes.bool,
  onClose: PropTypes.func,
};

Modal.defaultProps = {
  closeBtn: true,
};

export default Modal;
